/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit App/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppAction from './AppAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import useListItemDataOnSubmit from './useListItemDataOnSubmit.js'



/** @type {import('Simple/types.js').View} */
export default function App({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/Apps/Content/App"
  
}) {
let appShortNameValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'shortName',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let appLaunchersValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'launchers',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceLs}
 marginRight={dtSpaceLs}
 marginTop={dtSpaceXxs}
 marginBottom={dtSpaceXxs}
 size="xmedium"
 weight="medium"
 color={dtColorsNeutral500}
 data="app.shortName"
 text={appShortNameValueData}
/>
<div
  data-testid="App.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(appLaunchersValueData) && appLaunchersValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="launcher"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/AppAction(${item?.id ?? item?._id ?? index})`}
      >
<AppAction
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/AppAction(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    let onSubmit = useListItemDataOnSubmit(props)
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      onSubmit={onSubmit}
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }